export default class BasicController {

  constructor(app, pageId) {
    this.app = app;
    this.pageId = pageId;
  }
  show(path) {
    const app = this.app;
    const pageId = this.pageId || path;

    const model = app;
    app.populate(pageId, model);
    app.swapPage(pageId);
  }
}